export default __webpack_public_path__ + "static/media/image2.00c137a6.bmp";